import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import { Spinner, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import MaskedInput from "react-text-mask";
import ClaveErrorModal from "./ClaveErrorModal.jsx";
import ClaveSeguridadModal from "./ClaveSeguridadModal.jsx";
import ModalEjecutivo from "./ModalEjecutivo.jsx";
import { rutMask } from "../../utils/inputMask.js";
import { oacento } from "../../utils/caracteresUTF8.js";
import { initialValuesClaveSeguridad } from "../../utils/initialValues/formClaveSeguridad.js";
import { handleSubmitClaveSeguridad } from "../../utils/handleSubmit/formClaveSeguridad.js";
import { validationSchemaClaveSeguridad } from "../../utils/validationSchemaForm.js";
import images from "../../assets/images.tsx";

const FormClaveSeguridad = () => {

    let history = useNavigate();

    const [modalShow, setModalShow] = useState(false);
    const [modalError, setmodalError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showModalEjecutivo, setShowModalEjecutivo] = useState(false)

    const handleClose = () => setModalShow(false);
    const handleError = () => setmodalError(false);
    const handleShow = () => setModalShow(true);
    const handleCloseE = () => setShowModalEjecutivo(false);

    function volver() {
        history(-1);
    }

    const handleSubmit = (values) => {
        handleSubmitClaveSeguridad({
            values: values,
            changeLoading: setIsLoading,
            changeModal: setmodalError,
            showModalEjecutivo: setShowModalEjecutivo,
            history: history
        })
    }

    return (
        <Formik initialValues={initialValuesClaveSeguridad} validationSchema={validationSchemaClaveSeguridad} onSubmit={handleSubmit}>
            {(formik) => (
                <Form>
                    <div className="input-wrapper">
                        <Field name="rut">
                            {({ field, meta }) => (
                                <div className="form-group input-wrapper">
                                    <span>RUT del afiliado, pensionado o beneficiario de pensi{oacento}n de sobrevivencia</span>
                                    <MaskedInput
                                        {...field}
                                        mask={rutMask}
                                        type="text"
                                        className={`form-control form-control-lg ${meta.touched ? (meta.error ? "is-invalid" : "is-valid") : ""}`}
                                        id="rut"
                                        name="rut"
                                        aria-describedby="rutAyuda"
                                        placeholder=""
                                        autoComplete="off" />
                                    <label htmlFor="rut" className="control-label">
                                        RUT
                                    </label>
                                    <small id="rutAyuda" className={`form-text ${meta.touched && meta.error ? 'is-invalid' : ''}`}>
                                        {meta.touched && meta.error ? meta.error : "Ej. 12.345.678-9."}
                                    </small>
                                </div>
                            )}
                        </Field>
                        <Field name="clave">
                            {({ field, meta }) => (
                                <div className="form-group input-wrapper">
                                    <span> Clave de seguridad
                                        <a className="text-decoration-none align-svg" onClick={handleShow}>
                                            <img src={images.question} alt="question" />
                                        </a>
                                    </span>
                                    <input
                                        {...field}
                                        type="password"
                                        className={`form-control form-control-lg ${meta.touched ? (meta.error ? "is-invalid" : "is-valid") : ""}`}
                                        id="clave"
                                        name="clave"
                                        aria-describedby="claveAyuda"
                                        autoComplete="off" />
                                    <label htmlFor="clave" className="control-label">
                                        Clave Seguridad
                                    </label>
                                    <small id="claveAyuda" className={`form-text ${meta.touched && meta.error ? 'is-invalid' : ''}`}>
                                        {meta.touched && meta.error ? meta.error : "Esta es una segunda clave que debes haber creado previamente."}
                                    </small>
                                </div>
                            )}
                        </Field>
                        <Field name="beneficiario">
                            {({ field, meta }) => (
                                <div className="form-check">
                                    <span className="label-checkbox">Indícanos si eres beneficiario</span>
                                    <label className="form-check-label mt-auto" htmlFor="beneficiario">
                                        <input
                                            type="checkbox"
                                            name="beneficiario"
                                            {...field}
                                            className="form-check-input"
                                            autoComplete="off" />
                                        <small className="beneficiario">
                                            Soy beneficiario de una Pensión de Sobrevivencia.
                                        </small>
                                    </label>
                                    <small
                                        id="terminosAyuda"
                                        className={`form-text ${meta.touched && meta.error ? 'is-invalid' : ''}`}>{meta.touched && meta.error ? meta.error : ""}
                                    </small>
                                </div>
                            )}
                        </Field>
                        <Field name="ejecutivoAfp">
                            {({ field, meta }) => (
                                <div className="form-check">
                                    <span className="label-checkbox">Indícanos si eres ejecutivo de la AFP.</span>
                                    <label className="form-check-label mt-auto" htmlFor="mandatario">
                                        <input
                                            type="checkbox"
                                            name="ejecutivoAfp"
                                            {...field}
                                            className="form-check-input"
                                            autoComplete="off"
                                        />
                                        <small className="mandatario">
                                            Hago ingreso asistido de la solicitud como ejecutivo de AFP Modelo.
                                        </small>
                                    </label>
                                    <small
                                        id="mandatarioAyuda"
                                        className={`form-text ${meta.touched && meta.error ? 'is-invalid' : ''}`}>{meta.touched && meta.error ? meta.error : ""}
                                    </small>
                                </div>
                            )}
                        </Field>
                    </div>
                    <div className="justify-content-center d-flex mt-4">
                        <Button
                            type="submit"
                            id="claveSeguridad"
                            variant="success"
                            className="col-md-12"
                            disabled={!(formik.isValid && formik.dirty)}>
                            {isLoading ? <Spinner animation="border" variant="light" size="sm" /> : "Continuar"}
                        </Button>

                        <ClaveErrorModal show={modalError} onHide={handleError} />
                        <ClaveSeguridadModal show={modalShow} onHide={handleClose} />
                        <ModalEjecutivo show={showModalEjecutivo} onHide={handleCloseE} />
                    </div>
                    <div className="row">
                        <div className="col justify-content-center d-flex">
                            <a className="volver" onClick={volver}>Iniciar proceso con rut  y número de serie</a>
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default FormClaveSeguridad;